import React, { useEffect, useState } from "react";
import usePageBodyClass from "../utils/usePageBodyClass";
import ExamProctorWidget from "../components/ExamProctorWidget";
import "./SecondLevelExam.css";

const $ = window.$;

const DEFAULT_QUESTIONS = [
  {
    id: "q1", title: "Sum of Array Elements", difficulty: "Easy",
    description: "Write a function that takes an array of integers and returns the sum of all the elements in the array.",
    examples: [
      { input: "[1, 2, 3, 4, 5]", output: "15" },
      { input: "[-1, -2, 3]", output: "0" },
      { input: "[]", output: "0" },
      { input: "[42]", output: "42" },
    ],
    funcName: "sumArray",
    starterCode: {
      javascript: "function sumArray(arr) {\n    // write your code here\n\n}",
      python: "def sum_array(arr):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <vector>\nusing namespace std;\n\nint sumArray(vector<int>& arr) {\n    // write your code here\n    return 0;\n}",
    },
    testCases: [
      { input: [[1, 2, 3, 4, 5]], expected: 15, hidden: false },
      { input: [[-1, -2, 3]], expected: 0, hidden: false },
      { input: [[]], expected: 0, hidden: true },
      { input: [[100, 200, 300]], expected: 600, hidden: true },
    ],
  },
  {
    id: "q2", title: "Reverse a String", difficulty: "Easy",
    description: "Write a function that takes a string and returns it reversed.",
    examples: [
      { input: '"hello"', output: '"olleh"' },
      { input: '"TCS"', output: '"SCT"' },
      { input: '"racecar"', output: '"racecar"' },
      { input: '"a b c"', output: '"c b a"' },
    ],
    funcName: "reverseString",
    starterCode: {
      javascript: "function reverseString(str) {\n    // write your code here\n\n}",
      python: "def reverse_string(s):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <string>\n#include <algorithm>\nusing namespace std;\n\nstring reverseString(string s) {\n    // write your code here\n    return \"\";\n}",
    },
    testCases: [
      { input: ["hello"], expected: "olleh", hidden: false },
      { input: ["TCS"], expected: "SCT", hidden: false },
      { input: ["coding"], expected: "gnidoc", hidden: true },
    ],
  },
  {
    id: "q3", title: "Factorial of a Number", difficulty: "Medium",
    description: "Write a function that returns the factorial of a non-negative integer <code>n</code>. Factorial of 0 is 1.",
    examples: [
      { input: "5", output: "120" },
      { input: "0", output: "1" },
      { input: "1", output: "1" },
      { input: "6", output: "720" },
    ],
    funcName: "factorial",
    starterCode: {
      javascript: "function factorial(n) {\n    // write your code here\n\n}",
      python: "def factorial(n):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\nusing namespace std;\n\nlong long factorial(int n) {\n    // write your code here\n    return 1;\n}",
    },
    testCases: [
      { input: [5], expected: 120, hidden: false },
      { input: [0], expected: 1, hidden: false },
      { input: [10], expected: 3628800, hidden: true },
    ],
  },
  {
    id: "q4", title: "Find Maximum Element", difficulty: "Easy",
    description: "Write a function that finds and returns the maximum integer in a given array.",
    examples: [
      { input: "[1, 5, 3, 9, 2]", output: "9" },
      { input: "[-10, -3, -5]", output: "-3" },
      { input: "[42]", output: "42" },
      { input: "[4, 4, 4]", output: "4" },
    ],
    funcName: "findMax",
    starterCode: {
      javascript: "function findMax(arr) {\n    // write your code here\n\n}",
      python: "def find_max(arr):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <vector>\nusing namespace std;\n\nint findMax(vector<int>& arr) {\n    // write your code here\n    return 0;\n}",
    },
    testCases: [
      { input: [[1, 5, 3, 9, 2]], expected: 9, hidden: false },
      { input: [[-10, -3, -5]], expected: -3, hidden: false },
      { input: [[42]], expected: 42, hidden: true },
      { input: [[100, 200, 300, 50]], expected: 300, hidden: true },
    ],
  },
  {
    id: "q5", title: "Check Palindrome", difficulty: "Easy",
    description: "Write a function that returns <code>true</code> if a given string is a palindrome, and <code>false</code> otherwise.",
    examples: [
      { input: '"racecar"', output: "true" },
      { input: '"hello"', output: "false" },
      { input: '"a"', output: "true" },
      { input: '"abba"', output: "true" },
    ],
    funcName: "isPalindrome",
    starterCode: {
      javascript: "function isPalindrome(str) {\n    // write your code here\n\n}",
      python: "def is_palindrome(s):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <string>\nusing namespace std;\n\nbool isPalindrome(string s) {\n    // write your code here\n    return false;\n}",
    },
    testCases: [
      { input: ["racecar"], expected: true, hidden: false },
      { input: ["hello"], expected: false, hidden: false },
      { input: ["a"], expected: true, hidden: true },
      { input: ["madam"], expected: true, hidden: true },
    ],
  },
  {
    id: "q6", title: "Count Vowels", difficulty: "Easy",
    description: "Write a function that takes a string and returns the number of vowels (a, e, i, o, u) present in it.",
    examples: [
      { input: '"hello world"', output: "3" },
      { input: '"rhythm"', output: "1" },
      { input: '"aeiou"', output: "5" },
      { input: '"xyz"', output: "0" },
    ],
    funcName: "countVowels",
    starterCode: {
      javascript: "function countVowels(str) {\n    // write your code here\n\n}",
      python: "def count_vowels(s):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <string>\nusing namespace std;\n\nint countVowels(string s) {\n    // write your code here\n    return 0;\n}",
    },
    testCases: [
      { input: ["hello world"], expected: 3, hidden: false },
      { input: ["rhythm"], expected: 1, hidden: false },
      { input: ["aeiou"], expected: 5, hidden: true },
      { input: ["xyz"], expected: 0, hidden: true },
    ],
  },
  {
    id: "q7", title: "Fibonacci Sequence", difficulty: "Medium",
    description: "Write a function to return the <code>n</code>th number in the Fibonacci sequence. Assume sequence starts: 0, 1, 1, 2, 3...",
    examples: [
      { input: "5", output: "5" },
      { input: "6", output: "8" },
      { input: "0", output: "0" },
      { input: "10", output: "55" },
    ],
    funcName: "fibonacci",
    starterCode: {
      javascript: "function fibonacci(n) {\n    // write your code here\n\n}",
      python: "def fibonacci(n):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\nusing namespace std;\n\nint fibonacci(int n) {\n    // write your code here\n    return 0;\n}",
    },
    testCases: [
      { input: [5], expected: 5, hidden: false },
      { input: [6], expected: 8, hidden: false },
      { input: [0], expected: 0, hidden: true },
      { input: [10], expected: 55, hidden: true },
    ],
  },
  {
    id: "q8", title: "Missing Number", difficulty: "Medium",
    description: "You are given an array of <code>n-1</code> integers containing numbers from 1 to <code>n</code>. Find the missing number.",
    examples: [
      { input: "[1, 2, 4, 5], n=5", output: "3" },
      { input: "[2, 3, 1, 5], n=5", output: "4" },
      { input: "[1, 2, 3], n=4", output: "4" },
      { input: "[2], n=2", output: "1" },
    ],
    funcName: "missingNumber",
    starterCode: {
      javascript: "function missingNumber(arr, n) {\n    // write your code here\n\n}",
      python: "def missing_number(arr, n):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\n#include <vector>\nusing namespace std;\n\nint missingNumber(vector<int>& arr, int n) {\n    // write your code here\n    return 0;\n}",
    },
    testCases: [
      { input: [[1, 2, 4, 5], 5], expected: 3, hidden: false },
      { input: [[2, 3, 1, 5], 5], expected: 4, hidden: false },
      { input: [[1, 2, 3], 4], expected: 4, hidden: true },
      { input: [[2], 2], expected: 1, hidden: true },
    ],
  },
  {
    id: "q9", title: "Check Prime Number", difficulty: "Easy",
    description: "Write a function to check if a given integer is a prime number. Return <code>true</code> or <code>false</code>.",
    examples: [
      { input: "7", output: "true" },
      { input: "10", output: "false" },
      { input: "2", output: "true" },
      { input: "1", output: "false" },
    ],
    funcName: "isPrime",
    starterCode: {
      javascript: "function isPrime(n) {\n    // write your code here\n\n}",
      python: "def is_prime(n):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\nusing namespace std;\n\nbool isPrime(int n) {\n    // write your code here\n    return false;\n}",
    },
    testCases: [
      { input: [7], expected: true, hidden: false },
      { input: [10], expected: false, hidden: false },
      { input: [2], expected: true, hidden: true },
      { input: [1], expected: false, hidden: true },
      { input: [97], expected: true, hidden: true },
    ],
  },
  {
    id: "q10", title: "Calculate Power", difficulty: "Easy",
    description: "Write a function that calculates <code>base</code> raised to the power of <code>exp</code>.",
    examples: [
      { input: "2, 3", output: "8" },
      { input: "5, 2", output: "25" },
      { input: "10, 0", output: "1" },
      { input: "0, 5", output: "0" },
    ],
    funcName: "power",
    starterCode: {
      javascript: "function power(base, exp) {\n    // write your code here\n\n}",
      python: "def power(base, exp):\n    # write your code here\n    pass",
      cpp: "#include <iostream>\nusing namespace std;\n\nlong long power(int base, int exp) {\n    // write your code here\n    return 1;\n}",
    },
    testCases: [
      { input: [2, 3], expected: 8, hidden: false },
      { input: [5, 2], expected: 25, hidden: false },
      { input: [10, 0], expected: 1, hidden: true },
      { input: [3, 4], expected: 81, hidden: true },
    ],
  },
];

export default function SecondLevelExam() {
  usePageBodyClass("page-second-level");
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    // Clock
    const clockTimer = setInterval(() => {
      $("#liveDateTime").text(
        new Date().toLocaleDateString("en-US", {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
    }, 1000);

    // Anti-Cheat (Disable Context Menu) — everywhere except the code editor
    $(document).on("contextmenu.pageS2 selectstart.pageS2 copy.pageS2 paste.pageS2", (e) => {
      if (e.target.id !== "codeEditor") e.preventDefault();
    });

    let examSubmitted = false;
    let closeAttempted = false;

    // Anti-Cheat (Tab/Window Switching) — same 2-strike pattern
    let tabSwitchCount = 0;
    $(document).on("visibilitychange.pageS2", function () {
      if (document.hidden && localStorage.getItem("examStatus") === "locked") {
        tabSwitchCount++;
        if (tabSwitchCount >= 2) {
          alert("VIOLATION LIMIT EXCEEDED: Tab switching detected. Auto-submitting your assessment!");
          submitExam(true, "tab-switch-violation");
        } else {
          alert(`WARNING (${tabSwitchCount}/2): Switching windows is forbidden!`);
        }
      }
    });

    // Fullscreen and Native Browser Close Guards
    const handleBeforeUnload = (e) => {
      if (examSubmitted) return;
      closeAttempted = true;
      e.preventDefault();
      e.returnValue = ""; 
    };

    const handleWindowFocus = () => {
      if (closeAttempted) {
        closeAttempted = false;
        setShowWarning(true);
      }
    };

    const handleFullscreenChange = () => {
      if (examSubmitted) return;
      if (!document.fullscreenElement && !document.webkitFullscreenElement) {
        setShowWarning(true);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("focus", handleWindowFocus);
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);

    // Login Logic
    let candidateName = "";
    let candidateId = "";

    const prefillCode = new URLSearchParams(window.location.search).get("code");
    if (prefillCode) $("#loginAccessCode").val(prefillCode.toUpperCase());

    $("#candidateLoginForm").on("submit.pageS2", function (e) {
      e.preventDefault();

      $("#accessCodeError").hide();
      $("#loginAccessCode").removeClass("is-invalid");

      candidateName = $("#loginName").val().trim();
      const email = $("#loginEmail").val().trim();
      const phone = $("#loginPhone").val().trim();
      const enteredCode = $("#loginAccessCode").val().trim();

      const invites = JSON.parse(localStorage.getItem("round2Invitations") || "{}");
      const inviteKey = Object.keys(invites).find(
        (k) => (invites[k].email || "").toLowerCase() === email.toLowerCase()
      );
      const invite = inviteKey ? invites[inviteKey] : null;

      if (!invite || !enteredCode || enteredCode.toUpperCase() !== (invite.code || "").toUpperCase()) {
        $("#loginAccessCode").addClass("is-invalid");
        $("#accessCodeError").show();
        return;
      }

      candidateId = "cand_" + Date.now();

      localStorage.setItem("candidateName", candidateName);
      localStorage.setItem("currentCandidateId", candidateId);
      localStorage.setItem("candidateEmail", email);
      localStorage.setItem("candidatePhone", phone);

      invites[inviteKey] = { ...invite, usedAt: new Date().toISOString() };
      localStorage.setItem("round2Invitations", JSON.stringify(invites));

      $("#candidateDisplay").text(candidateName);

      $("#loginScreen").removeClass("show");
      $("#startScreen").addClass("show");
    });

    // Sync Questions with Dynamic Admin Dashboard Setup
    let QUESTIONS = JSON.parse(localStorage.getItem("codingQuestionBank") || "[]");

    if (QUESTIONS.length === 0) {
      QUESTIONS = DEFAULT_QUESTIONS;
      localStorage.setItem("codingQuestionBank", JSON.stringify(QUESTIONS));
    }

    const examDurationMinutes = 45;
    let currentIndex = 0;
    let currentLang = "javascript";
    const userCode = {};
    const questionStatus = {};
    const lastRunSummary = {};

    QUESTIONS.forEach((q) => {
      userCode[q.id] = {
        javascript: q.starterCode.javascript,
        python: q.starterCode.python,
        cpp: q.starterCode.cpp,
      };
      questionStatus[q.id] = "not-attempted";
    });
    let timeLeftSeconds = examDurationMinutes * 60;
    let timerInterval = null;

    // Evaluation Logic Engine (Supports Multi-Lang Mocking)
    function runTestCase(code, funcName, args) {
      try {
        const body = '"use strict";\n' + code + "\nreturn " + funcName + "(..." + JSON.stringify(args) + ");";
        // eslint-disable-next-line no-new-func
        const runner = new Function(body);
        return { ok: true, result: runner() };
      } catch (err) {
        return { ok: false, error: err.message };
      }
    }

    function evaluateQuestion(question, code, lang) {
      if (lang === "javascript") {
        const results = question.testCases.map((tc) => {
          const run = runTestCase(code, question.funcName, tc.input);
          let pass = false;
          try {
            pass = run.ok && JSON.stringify(run.result) === JSON.stringify(tc.expected);
          } catch (e) {
            pass = run.result === tc.expected;
          }
          return { pass, hidden: tc.hidden, input: tc.input, expected: tc.expected, actual: run.ok ? run.result : undefined, error: run.ok ? null : run.error };
        });
        return { results, passed: results.filter((r) => r.pass).length, total: results.length };
      } else {
        const defaultCode = question.starterCode[lang].trim();
        const hasModified = code.trim() !== defaultCode && code.trim().length > defaultCode.length - 10;

        const results = question.testCases.map((tc) => {
          return {
            pass: hasModified,
            hidden: tc.hidden,
            input: tc.input,
            expected: tc.expected,
            actual: hasModified ? tc.expected : undefined,
            error: hasModified ? null : "Simulated Compiler Error: Method implementation missing.",
          };
        });
        return { results, passed: hasModified ? results.length : 0, total: results.length };
      }
    }

    // UI Renderers
    function renderSidebar() {
      const $list = $("#qNavList").empty();
      QUESTIONS.forEach((q, idx) => {
        const activeClass = idx === currentIndex ? " active" : "";
        $list.append(`
            <div class="q-nav-btn ${activeClass}" data-idx="${idx}">
              <span>Q${idx + 1}. ${q.title}</span>
              <span class="status-dot ${questionStatus[q.id]}"></span>
            </div>
          `);
      });
      $(".q-nav-btn").on("click.pageS2", function () {
        saveCode();
        currentIndex = $(this).data("idx");
        renderAll();
      });
    }

    function renderQuestion() {
      const q = QUESTIONS[currentIndex];
      $("#qTitle").text(`Q${currentIndex + 1}. ${q.title}`);
      $("#qDiffBadge").text(q.difficulty).removeClass("Easy Medium Hard").addClass(q.difficulty);
      $("#qDesc").html(q.description);

      let exHtml = "";
      q.examples.forEach((ex, i) => {
        exHtml += `<div class="example-box"><strong>Example ${i + 1}:</strong><br>Input: <code>${ex.input}</code><br>Output: <code>${ex.output}</code></div>`;
      });
      $("#qExamples").html(exHtml);

      $("#codeEditor").val(userCode[q.id][currentLang]);
      renderConsole(lastRunSummary[q.id]);

      $("#prevQBtn").prop("disabled", currentIndex === 0);
      $("#nextQBtn").html(currentIndex === QUESTIONS.length - 1 ? '<i class="fa-solid fa-save me-1"></i> Save' : 'Next <i class="fa-solid fa-arrow-right ms-2"></i>');
    }

    function renderConsole(evalResult) {
      const $c = $("#consoleBox");

      if (currentLang !== "javascript") {
        $c.prepend(
          '<div class="alert alert-dark text-warning p-2 mb-2" style="font-size:0.75rem;"><i class="fa-solid fa-info-circle me-1"></i> Note: Python and C++ compilation is simulated in this UI demo.</div>'
        );
      }

      if (!evalResult) {
        if (currentLang === "javascript") {
          $c.html('<div class="text-muted"><i class="fa-solid fa-terminal me-2"></i>Console output will appear here after you run your code.</div>');
        }
        return;
      }

      let html = `<div class="tc-summary">${evalResult.passed} / ${evalResult.total} Test Cases Passed</div>`;
      evalResult.results.forEach((r) => {
        html += `<div class="tc-row d-flex align-items-center">
                    <span class="tc-pill ${r.pass ? "pass" : "fail"} me-2">${r.pass ? "PASS" : "FAIL"}</span>`;
        if (r.hidden) html += `<span class="text-muted small flex-grow-1">Hidden Test Case</span>`;
        else html += `<span class="text-light small flex-grow-1" style="font-family: monospace;">Input: ${JSON.stringify(r.input)} | Expected: ${JSON.stringify(r.expected)}</span>`;
        html += `</div>`;
        if (r.error) html += `<div class="console-error small ms-5">${r.error}</div>`;
      });
      $c.html(html);
    }

    function saveCode() {
      userCode[QUESTIONS[currentIndex].id][currentLang] = $("#codeEditor").val();
    }
    function renderAll() {
      renderSidebar();
      renderQuestion();
    }

    // Timer
    function startTimer() {
      $("#timerDisplay").text(`${Math.floor(timeLeftSeconds / 60)}:00`);
      timerInterval = setInterval(() => {
        timeLeftSeconds--;
        if (timeLeftSeconds <= 0) {
          clearInterval(timerInterval);
          submitExam(true);
          return;
        }
        $("#timerDisplay").text(`${String(Math.floor(timeLeftSeconds / 60)).padStart(2, "0")}:${String(timeLeftSeconds % 60).padStart(2, "0")}`);
      }, 1000);
    }

    // Event Listeners
    $("#startExamBtn").on("click.pageS2", () => {
      $("#startScreen").removeClass("show");
      $("#headerRightControls").attr("style", "display: flex !important;");
      $("#examShell").addClass("show");
      renderAll();
      startTimer();
    });

    // Language Switcher Logic
    $("#langSelect").on("change.pageS2", function () {
      saveCode();
      currentLang = $(this).val();
      renderAll();
    });

    $("#runCodeBtn").on("click.pageS2", () => {
      saveCode();
      const q = QUESTIONS[currentIndex];

      const evalResult = evaluateQuestion(q, userCode[q.id][currentLang], currentLang);
      lastRunSummary[q.id] = evalResult;
      questionStatus[q.id] = evalResult.passed === evalResult.total ? "solved" : "attempted";

      renderConsole(evalResult);
      renderSidebar();
    });

    $("#resetCodeBtn").on("click.pageS2", () => {
      if (confirm("Reset code to starter template for this language?")) {
        userCode[QUESTIONS[currentIndex].id][currentLang] = QUESTIONS[currentIndex].starterCode[currentLang];
        $("#codeEditor").val(QUESTIONS[currentIndex].starterCode[currentLang]);
        renderConsole(null);
      }
    });

    $("#nextQBtn").on("click.pageS2", () => {
      saveCode();
      if (currentIndex < QUESTIONS.length - 1) {
        currentIndex++;
        renderAll();
      }
    });
    $("#prevQBtn").on("click.pageS2", () => {
      saveCode();
      if (currentIndex > 0) {
        currentIndex--;
        renderAll();
      }
    });

    // Indentation support for Editor
    $("#codeEditor").on("keydown.pageS2", function (e) {
      if (e.key === "Tab") {
        e.preventDefault();
        const s = this.selectionStart;
        const end = this.selectionEnd;
        this.value = this.value.substring(0, s) + "    " + this.value.substring(end);
        this.selectionStart = this.selectionEnd = s + 4;
      }
    });

    // Submit System linked to Admin Dashboard
    $("#submitExamBtn").on("click.pageS2", () => {
      if (confirm("Submit assessment? You cannot modify code after submission.")) submitExam(false);
    });

    function submitExam(auto, reason) {
      examSubmitted = true;
      if (timerInterval) clearInterval(timerInterval);
      saveCode();

      let totalPassed = 0;
      let totalCases = 0;
      QUESTIONS.forEach((q) => {
        const res = evaluateQuestion(q, userCode[q.id][currentLang], currentLang);
        totalPassed += res.passed;
        totalCases += res.total;
      });

      const roundScorePct = ((totalPassed / totalCases) * 100).toFixed(1);

      const rProgress = JSON.parse(localStorage.getItem("roundProgressData") || "{}");
      if (!rProgress[candidateId]) rProgress[candidateId] = { r1: "PASS", r2: "PENDING", r3: "PENDING", r4: "PENDING", r5: "PENDING" };
      rProgress[candidateId].r2 = parseFloat(roundScorePct) >= 70 ? "PASS" : "FAIL";
      localStorage.setItem("roundProgressData", JSON.stringify(rProgress));

      const s2Results = JSON.parse(localStorage.getItem("secondLevelResults") || "[]");
      s2Results.push({
        candidateId: candidateId,
        candidateName: candidateName,
        email: localStorage.getItem("candidateEmail") || "N/A",
        phone: localStorage.getItem("candidatePhone") || "N/A",
        language: currentLang,
        totalPassed: totalPassed,
        totalCases: totalCases,
        scorePct: roundScorePct,
        submittedAt: new Date().toISOString(),
      });
      localStorage.setItem("secondLevelResults", JSON.stringify(s2Results));

      $("#examShell").removeClass("show");
      $("#headerRightControls").attr("style", "display: none !important;");
      $("#resultCandidateLine").text(
        reason === "tab-switch-violation"
          ? "Auto-submitted: switching windows/tabs is prohibited during the exam."
          : auto
          ? "Auto-submitted due to time limits."
          : "Your code has been uploaded to the admin dashboard."
      );
      $("#resultBigScore").text(totalPassed);
      $("#resultOfScore").text(totalCases);
      $("#resultScreen").addClass("show");
    }

    $("#closeResultBtn").on("click.pageS2", () => window.close());

    return () => {
      clearInterval(clockTimer);
      if (timerInterval) clearInterval(timerInterval);
      $(document).off(".pageS2");
      $(
        "#candidateLoginForm, .q-nav-btn, #startExamBtn, #langSelect, #runCodeBtn, #resetCodeBtn, #nextQBtn, #prevQBtn, #codeEditor, #submitExamBtn, #closeResultBtn"
      ).off(".pageS2");
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("focus", handleWindowFocus);
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener("webkitfullscreenchange", handleFullscreenChange);
    };
  }, []);

  return (
    <div className="page-second-level">
      <ExamProctorWidget />

      {/* Top Window Switch Guard */}
      <div className="top-hover-guard">
        <button
          className="mock-close-btn"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setShowWarning(true); 
          }}
        >
          <i className="fa-solid fa-xmark me-2"></i>Switch Window
        </button>
      </div>

      {/* In-App Fullscreen Warning Modal */}
      {showWarning && (
        <div className="custom-warning-overlay">
          <div className="custom-warning-box">
            <i className="fa-solid fa-triangle-exclamation fa-3x text-danger mb-3"></i>
            <h4 className="fw-bold mb-2">Action Denied</h4>
            <p className="text-secondary fs-5 mb-4">
              You should immediately continue the exam or it will be terminated.
            </p>
            <button className="btn btn-danger px-4 fw-bold" onClick={() => {
              setShowWarning(false);
              // Force candidate back into fullscreen
              if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch((err) => console.log(err));
              }
            }}>
              Return to Exam
            </button>
          </div>
        </div>
      )}

      <div className="top-header d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-3">
          <h5 className="mb-0 text-warning">
            <i className="fa-solid fa-laptop-code me-2"></i>Test Cases Exam
          </h5>
          <span className="badge bg-secondary px-3 py-2" id="candidateDisplay">Candidate Name</span>
        </div>

        <div className="header-datetime d-none d-md-flex align-items-center">
          <i className="fa-regular fa-calendar-days me-2 text-warning"></i>
          <span id="liveDateTime">Loading Date &amp; Time...</span>
        </div>

        <div className="d-flex align-items-center gap-3" id="headerRightControls">
          <div className="bg-danger text-white px-3 py-1 rounded fw-bold">
            <i className="fa-regular fa-clock me-1"></i> <span id="timerDisplay">45:00</span>
          </div>
          <button className="btn btn-outline-light btn-sm fw-bold" id="submitExamBtn">Submit Code</button>
        </div>
      </div>

      <div className="center-screen show" id="loginScreen">
        <div className="center-card border border-light text-start">
          <div className="text-center mb-4">
            <i className="fa-solid fa-user-lock fa-3x text-primary mb-3"></i>
            <h4 className="fw-bold mb-1">Candidate Login</h4>
            <p className="text-muted small">Please verify your details to proceed to the exam.</p>
          </div>
          <form id="candidateLoginForm">
            <div className="mb-3">
              <label className="form-label small fw-bold text-secondary">Full Name</label>
              <input type="text" className="form-control" id="loginName" placeholder="e.g. John Doe" required />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-bold text-secondary">Phone Number</label>
              <input type="tel" className="form-control" id="loginPhone" placeholder="1234567890" required />
            </div>
            <div className="mb-3">
              <label className="form-label small fw-bold text-secondary">Email Address</label>
              <input type="email" className="form-control" id="loginEmail" placeholder="john@example.com" required />
            </div>
            <div className="mb-4">
              <label className="form-label small fw-bold text-secondary">Access Code</label>
              <input
                type="text"
                className="form-control text-uppercase"
                id="loginAccessCode"
                placeholder="Code from your Round 2 invite email"
                autoComplete="off"
                required
              />
              <div className="error-msg" id="accessCodeError">
                Invalid access code for this email. Please check the code from your invite email.
              </div>
            </div>
            <button type="submit" className="btn btn-primary w-100 fw-bold py-2">Login &amp; Continue</button>
          </form>
        </div>
      </div>

      <div className="center-screen" id="startScreen">
        <div className="center-card border border-light">
          <i className="fa-solid fa-code fa-3x text-primary mb-3"></i>
          <h4 className="fw-bold mb-1">Round 2: Technical &amp; Coding</h4>
          <p className="text-muted small mb-4">
            You have <span id="instrDuration" className="fw-bold">45</span> minutes to solve algorithmic problems.
          </p>

          <div className="text-start bg-light p-3 rounded mb-4 border">
            <ul className="mb-0 small text-secondary">
              <li>Select your preferred programming language (JavaScript, Python, C++) from the code editor dropdown.</li>
              <li>Use <strong>Run Code</strong> to execute your solution against visible and hidden test cases.</li>
              <li>Your code must return the specified output format exactly.</li>
              <li>The exam will auto-submit when the timer expires.</li>
            </ul>
          </div>

          <button className="btn btn-primary w-100 fw-bold py-2" id="startExamBtn">
            Begin Assessment <i className="fa-solid fa-arrow-right ms-2"></i>
          </button>
        </div>
      </div>

      <div className="exam-shell" id="examShell">
        <div className="exam-body-flex">
          <div className="q-sidebar">
            <div className="q-sidebar-label">
              <i className="fa-solid fa-list-check me-2"></i>Problems
            </div>
            <div id="qNavList"></div>
          </div>

          <div className="exam-main">
            <div className="panel-box flex-row gap-3 p-0 border-0 bg-transparent">
              <div className="panel-box problem-pane">
                <div className="d-flex align-items-center mb-3">
                  <span className="q-title" id="qTitle">Question Title</span>
                  <span className="diff-badge" id="qDiffBadge">Easy</span>
                </div>
                <div className="q-desc" id="qDesc">Problem statement here.</div>
                <h6 className="fw-bold text-secondary fs-6 mt-2 mb-3 border-bottom pb-2">Examples</h6>
                <div id="qExamples"></div>
              </div>

              <div className="panel-box editor-pane">
                <div className="editor-toolbar">
                  <select
                    id="langSelect"
                    className="form-select form-select-sm fw-bold bg-light border-secondary text-primary"
                    style={{ width: "140px", display: "inline-block" }}
                  >
                    <option value="javascript">JavaScript (ES6)</option>
                    <option value="python">Python 3.10</option>
                    <option value="cpp">C++ 17</option>
                  </select>

                  <div>
                    <button className="btn btn-sm btn-outline-secondary fw-bold me-2" id="resetCodeBtn">
                      <i className="fa-solid fa-rotate-left me-1"></i> Reset
                    </button>
                    <button className="btn btn-sm btn-success fw-bold" id="runCodeBtn">
                      <i className="fa-solid fa-play me-1"></i> Run Code
                    </button>
                  </div>
                </div>

                <textarea id="codeEditor" spellCheck="false"></textarea>

                <div className="console-box" id="consoleBox">
                  <div className="text-muted">
                    <i className="fa-solid fa-terminal me-2"></i>Console output will appear here...
                  </div>
                </div>

                <div className="nav-buttons">
                  <button className="btn btn-outline-secondary fw-bold px-4" id="prevQBtn">
                    <i className="fa-solid fa-arrow-left me-2"></i> Prev
                  </button>
                  <button className="btn btn-primary fw-bold px-4" id="nextQBtn">
                    Next <i className="fa-solid fa-arrow-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="center-screen" id="resultScreen">
        <div className="center-card border border-light">
          <i className="fa-solid fa-check-circle fa-4x text-success mb-3"></i>
          <h3 className="fw-bold mb-1">Assessment Submitted</h3>
          <p className="text-muted mb-4" id="resultCandidateLine">Your code has been uploaded to the admin dashboard.</p>

          <div className="bg-light p-4 rounded border mb-4">
            <h1 className="display-4 fw-bold text-primary mb-0">
              <span id="resultBigScore">0</span>
              <span className="fs-4 text-secondary"> / <span id="resultOfScore">0</span></span>
            </h1>
            <p className="small text-muted fw-bold text-uppercase mt-2 mb-0">Total Test Cases Passed</p>
          </div>

          <button className="btn btn-outline-dark fw-bold px-5" id="closeResultBtn">Close Window</button>
        </div>
      </div>
    </div>
  );
}